export enum PLAN_PERMISSION_KEYS {
    SITE_SETUP = 'site-setup',
    TEAM_SETUP = 'team-setup',
    JOB_SETUP = 'job-setup',
    REPORTS = 'reports',
    ANALYSIS = 'analysis',

    ELECTRIC_CIRCUIT_MODULE = 'electric-circuit-module',

    USERS_LIMIT = 'users-limit',
    LOCATIONS_LIMIT = 'locations-limit',
}
